import {
  pickCoachControlTargetIndex,
  resolveExerciseStateIdFromRow,
  TE_STATE_PAUSED,
  TE_STATE_STARTED,
} from "../utils/coachExerciseNavigation";

/**
 * Exercise row + realtime maps used by Training floating bar / CoachExerciseActionsBar.
 */

/** Prefer running, then paused, else canonical next scheduled (same ordering intent as CoachExerciseControl). */
export function pickCoachFloatingBarExercise(exercises, exerciseStates) {
  const validExercises = [...(exercises || [])]
    .filter((ex) => ex && ex.te_id)
    .sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0));
  if (!validExercises.length) return null;

  const running = validExercises.find(
    (ex) => resolveExerciseStateIdFromRow(ex, exerciseStates) === TE_STATE_STARTED
  );
  if (running) return running;

  const paused = validExercises.find(
    (ex) => resolveExerciseStateIdFromRow(ex, exerciseStates) === TE_STATE_PAUSED
  );
  if (paused) return paused;

  const ix = pickCoachControlTargetIndex(exercises, exerciseStates);
  return validExercises[ix] ?? validExercises[0];
}

export function enrichExerciseForCoachControls(ex, maps) {
  if (!ex?.te_id) return null;
  const {
    exerciseTimers,
    sequenceTimers,
    currentSequences,
  } = maps || {};

  const timer =
    exerciseTimers && exerciseTimers[ex.te_id] !== undefined
      ? exerciseTimers[ex.te_id]
      : undefined;
  const sequenceTimer =
    sequenceTimers && sequenceTimers[ex.te_id] !== undefined
      ? sequenceTimers[ex.te_id]
      : undefined;
  const currentSequence =
    currentSequences && currentSequences[ex.te_id] !== undefined
      ? currentSequences[ex.te_id]
      : undefined;

  return {
    ...ex,
    timer,
    sequenceTimer,
    currentSequence,
  };
}
